import { render, staticRenderFns } from "./NavAdministration.vue?vue&type=template&id=4044fbc9&"
import script from "./NavAdministration.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NavAdministration.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NavAdministration.vue?vue&type=style&index=0&id=4044fbc9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports